/* arissai-exit-intent.js v28 — email-gated 10% code, builds your customer list */
(function(){
  "use strict";
  var KEY = "arissai_exit_intent_v1";
  var DISCOUNT_CODE = "ARISSAI10";
  if (sessionStorage.getItem(KEY) === "shown") return;
  if (localStorage.getItem(KEY) === "dismissed") return;

  var triggered = false, idleTimer = null;

  var css = document.createElement("style");
  css.textContent =
    '.arissai-exit__form{display:flex;flex-direction:column;gap:1rem;margin:1.6rem 0 .6rem}'+
    '.arissai-exit__email{width:100%;padding:1.4rem 1.6rem;border:1px solid #ccc;border-radius:99px;font-size:1.4rem;outline:none;box-sizing:border-box;text-align:center}'+
    '.arissai-exit__email:focus{border-color:#d4af37}'+
    '.arissai-exit__submit{width:100%;padding:1.5rem;background:#d4af37;color:#0f0f15;border:none;border-radius:99px;font-size:1.35rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:background .2s}'+
    '.arissai-exit__submit:hover{background:#e0bd4a}'+
    '.arissai-exit__submit:disabled{opacity:.6;cursor:wait}'+
    '.arissai-exit__skip{background:none;border:none;color:#999;font-size:1.1rem;text-decoration:underline;cursor:pointer;margin-top:.4rem}'+
    '.arissai-exit__err{color:#b3261e;font-size:1.15rem;margin:.4rem 0 0;display:none}';
  document.head.appendChild(css);

  function showCode(card){
    card.innerHTML =
      '<button class="arissai-exit__x" aria-label="Close" data-testid="exit-close">&times;</button>'+
      '<p class="arissai-exit__eyebrow">You are in</p>'+
      '<h2 class="arissai-exit__h">Here is your 10% code</h2>'+
      '<p class="arissai-exit__p">Tap the code to copy it, then treat yourself.</p>'+
      '<div class="arissai-exit__code" data-testid="exit-code">'+ DISCOUNT_CODE +'</div>'+
      '<button class="arissai-exit__cta" data-testid="exit-shop">Shop the Collection</button>'+
      '<p class="arissai-exit__fine">One use per customer · Auto-applies at checkout</p>';
    wireCommon(card);
    card.querySelector(".arissai-exit__cta").addEventListener("click", function(){
      try { navigator.clipboard.writeText(DISCOUNT_CODE); } catch(e){}
      closeModal();
      location.assign("/collections/all?discount=" + DISCOUNT_CODE);
    });
    card.querySelector(".arissai-exit__code").addEventListener("click", function(){
      try { navigator.clipboard.writeText(DISCOUNT_CODE); this.textContent = "Copied!"; var self=this; setTimeout(function(){ self.textContent = DISCOUNT_CODE; }, 1500); } catch(e){}
    });
  }

  var wrapRef = null;
  function closeModal(){
    if (!wrapRef) return;
    wrapRef.classList.remove("is-open");
    var w = wrapRef;
    setTimeout(function(){ w.remove(); }, 280);
    sessionStorage.setItem(KEY, "shown");
  }
  function dismissForever(){ localStorage.setItem(KEY, "dismissed"); closeModal(); }

  function wireCommon(card){
    var x = card.querySelector(".arissai-exit__x");
    if (x) x.addEventListener("click", dismissForever);
  }

  function buildModal(){
    var wrap = document.createElement("div");
    wrapRef = wrap;
    wrap.className = "arissai-exit"; wrap.setAttribute("data-testid","exit-intent-modal");
    wrap.innerHTML =
      '<div class="arissai-exit__bg"></div>'+
      '<div class="arissai-exit__card" role="dialog" aria-label="Special offer">'+
        '<button class="arissai-exit__x" aria-label="Close" data-testid="exit-close">&times;</button>'+
        '<p class="arissai-exit__eyebrow">Before you go</p>'+
        '<h2 class="arissai-exit__h">Get 10% off your first Arissai piece</h2>'+
        '<p class="arissai-exit__p">Drop your email to unlock the code, plus first look at every new drop.</p>'+
        '<form class="arissai-exit__form" data-testid="exit-email-form" method="post" action="/contact" novalidate>'+
          '<input type="hidden" name="form_type" value="customer">'+
          '<input type="hidden" name="utf8" value="\u2713">'+
          '<input type="hidden" name="contact[tags]" value="newsletter,exit-popup">'+
          '<input type="hidden" name="return_to" value="' + location.pathname + '?arissai_signed_up=1">'+
          '<input type="email" name="contact[email]" class="arissai-exit__email" data-testid="exit-email-input" placeholder="your@email.com" autocomplete="email" required>'+
          '<p class="arissai-exit__err" data-testid="exit-email-error">That email does not look right. Try again?</p>'+
          '<button type="submit" class="arissai-exit__submit" data-testid="exit-email-submit">Unlock my 10% code</button>'+
        '</form>'+
        '<button type="button" class="arissai-exit__skip" data-testid="exit-skip">No thanks</button>'+
      '</div>';
    document.body.appendChild(wrap);
    setTimeout(function(){ wrap.classList.add("is-open"); }, 30);

    var card = wrap.querySelector(".arissai-exit__card");
    wireCommon(card);
    wrap.querySelector(".arissai-exit__bg").addEventListener("click", closeModal);
    wrap.querySelector(".arissai-exit__skip").addEventListener("click", dismissForever);

    wrap.querySelector(".arissai-exit__form").addEventListener("submit", function(e){
      var input = card.querySelector(".arissai-exit__email");
      var err = card.querySelector(".arissai-exit__err");
      var email = (input.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){
        e.preventDefault();
        err.style.display = "block";
        input.focus();
        return;
      }
      err.style.display = "none";
      var btn = card.querySelector(".arissai-exit__submit");
      btn.disabled = true; btn.textContent = "Unlocking\u2026";
      localStorage.setItem("arissai_exit_pending", "1");
      var hiddenForm = document.getElementById("ArissaiCaptureForm");
      var hiddenEmail = document.getElementById("ArissaiCaptureEmail");
      if (hiddenForm && hiddenEmail){
        // proxy through the server-rendered Shopify form (proper tokens + captcha wiring)
        e.preventDefault();
        hiddenEmail.value = email;
        var hs = document.getElementById("ArissaiCaptureSubmit");
        if (hs) hs.click(); else hiddenForm.submit();
      }
      // resilience: if captcha stalls, reveal the code anyway so the shopper is never stuck
      setTimeout(function(){
        if (document.body.contains(card)) showCode(card);
      }, 7000);
    });
  }

  function maybeShow(){
    if (triggered) return;
    triggered = true;
    if ("requestIdleCallback" in window) requestIdleCallback(buildModal, { timeout: 400 });
    else setTimeout(buildModal, 50);
  }

  // Returning from signup redirect: show the code immediately
  if (localStorage.getItem("arissai_exit_pending") &&
      (location.search.indexOf("arissai_signed_up=1") > -1 || location.search.indexOf("customer_posted=true") > -1)){
    localStorage.removeItem("arissai_exit_pending");
    triggered = true;
    var wrap2 = document.createElement("div");
    wrapRef = wrap2;
    wrap2.className = "arissai-exit";
    wrap2.setAttribute("data-testid","exit-intent-modal");
    wrap2.innerHTML = '<div class="arissai-exit__bg"></div><div class="arissai-exit__card" role="dialog" aria-label="Your discount code"></div>';
    var mount = function(){
      document.body.appendChild(wrap2);
      showCode(wrap2.querySelector(".arissai-exit__card"));
      wrap2.querySelector(".arissai-exit__bg").addEventListener("click", closeModal);
      setTimeout(function(){ wrap2.classList.add("is-open"); }, 30);
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount);
    else mount();
    return;
  }

  // Desktop: exit-intent (mouse leaves viewport upward)
  if (!("ontouchstart" in window) && window.innerWidth > 749) {
    document.addEventListener("mouseleave", function(e){
      if (e.clientY < 20 && !triggered) maybeShow();
    });
  }
  // Mobile: time-based (45s idle) or scroll-to-bottom trigger
  else {
    setTimeout(maybeShow, 45000);
    window.addEventListener("scroll", function(){
      var sb = window.scrollY + window.innerHeight;
      if (sb > document.body.scrollHeight * 0.85) maybeShow();
    }, { passive: true });
  }
  // Universal: trigger after 90s of no interaction
  function resetIdle(){ if (idleTimer) clearTimeout(idleTimer); idleTimer = setTimeout(maybeShow, 90000); }
  ["mousemove","scroll","touchstart","keypress","click"].forEach(function(ev){
    document.addEventListener(ev, resetIdle, { passive: true });
  });
  resetIdle();
})();
